


































import Vue from 'vue'
import Component from 'vue-class-component'

import ConfigField from '../../../components/ConfigField/ConfigField.vue'
import PostApi from '../includes/logic/Api/PostApi'

@Component({
  components: {
    ConfigField,
  },
})
export default class VuChangeApi extends Vue {
  url = ''

  isValid():boolean {
    return this.url !== ''
  }

  setNewUrl():void {
    PostApi.changeApi(this.url)
  }

  resetNewUrl():void {
    PostApi.changeApi('')
  }
}
